import { useEffect, useState } from "react";
import { getUser, getUserAvatarData } from "@nusrif/services";
import { User } from "@nusrif/types";

export const ProfileUserInfo = () => {
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    const userData = getUser();
    setUser(userData);
  }, []);

  // Get display name (firstName + lastName or username)
  const getDisplayName = () => {
    if (!user) return "User";
    
    if (user.firstName && user.lastName) {
      return `${user.firstName} ${user.lastName}`;
    }
    
    return user.username || "User";
  };

  // Get contact info (email or phone number)
  const getContactInfo = () => {
    if (!user) return "";
    
    return user.phoneNumber || "";
  };
  // Get avatar data
  const getAvatarData = () => {
    if (!user) {
      return {
        initials: 'U',
        backgroundColor: 'bg-primary-blue'
      };
    }
    return getUserAvatarData(user);
  };
  const avatarData = getAvatarData();
  return (
    <div className="flex items-center gap-4 py-6">
      {/* Profile Avatar */}
      <div className={`w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl ${avatarData.backgroundColor}`}>
        {avatarData.initials}
      </div>
      
      {/* User Details */}
      <div className="flex-1">
        <h1 className="text-xl font-bold text-black">{getDisplayName()}</h1>
        <p className="text-sm text-gray-500">{getContactInfo()}</p>
      </div>
    </div>
  );
};